import { render, staticRenderFns } from "./auto-message-home.vue?vue&type=template&id=7f7a144a&scoped=true&"
import script from "./auto-message-home.vue?vue&type=script&lang=js&"
export * from "./auto-message-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7a144a",
  null
  
)

export default component.exports